import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import store from './store/index.js'
import config from '../config'

Vue.config.productionTip = false

Vue.mixin({
  data: function() {
    return {
      get config() {
        return config;
      }
    }
  }
})

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')



